import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { Box, Typography } from "@mui/material";

interface CouponProps {
  openCouponDialog: any;
  handleCloseCouponDialog: any;
}

const Coupon: React.FC<CouponProps> = ({
  openCouponDialog,
  handleCloseCouponDialog,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={openCouponDialog}
        onClose={handleCloseCouponDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box sx={{ padding: "1.5rem", minWidth: "18rem" }}>
          <Typography variant="body1" sx={{ color: "red", fontWeight: "600" }}>
            Error
          </Typography>
          <Typography variant="body1" sx={{ padding: "1rem 0px" }}>
            Invalid coupon code.
          </Typography>
          <Box sx={{ width: "100%", textAlign: "end", marginTop: "0.5rem" }}>
            <Button
              color="warning"
              onClick={handleCloseCouponDialog}
              sx={{ color: "red" }}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
};

export default Coupon;
